import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

const fetchMonthlyData = async (year, month, componentInstance) => {
  if (!year || month === null || month === undefined) {
    if (componentInstance) {
      componentInstance.$toast({
        component: ToastificationContent,
        props: {
          title: 'Parâmetros inválidos',
          text: 'Ano e mês são obrigatórios',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
    return { labels: [], datasets: [] }
  }

  try {
    // Obtém o perfil do usuário
    const profile = syslic.authentication.getProfile()
    if (!profile || !profile.id) {
      throw new Error('ID do usuário não encontrado')
    }

    const response = await axios.get(
      `https://syslic.com.br/reports/RetrieveReportByMonth?month=${month}&year=${year}&id=${profile.id}`,
      // `http://localhost:5000/Reports/RetrieveReportByMonth?month=${month}&year=${year}`,
    )

    return response.data
  } catch (error) {
    let errorMessage = 'Erro desconhecido ao buscar dados mensais'

    if (error.response) {
      errorMessage = error.response.data?.message || error.response.statusText
    } else if (error.request) {
      errorMessage = 'Sem resposta do servidor'
    } else {
      errorMessage = error.message
    }

    if (componentInstance) {
      componentInstance.$toast({
        component: ToastificationContent,
        props: {
          title: 'Erro na requisição',
          text: errorMessage,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }

    return { labels: [], datasets: [] }
  }
}

export default fetchMonthlyData
